<template lang="pug">
    v-form(ref="form" v-model="valid" lazy-validation)
        v-row
            v-col(cols="12")
                v-text-field(
                    v-model="formAddress.addressLine1"
                    label="Address Line 1 *"
                    type="text"
                    clearable
                    :rules="[rules.required]"
                    validate-on-blur
                )
        v-row
            v-col(cols="12")
                v-text-field(
                    v-model="formAddress.addressLine2"
                    label="Address Line 2"
                    type="text"
                    clearable
                    validate-on-blur
                )
        v-row
            v-col(cols="6")
                v-text-field(
                    v-model="formAddress.city"
                    label="City *"
                    type="text"
                    clearable
                    :rules="[rules.required]"
                    validate-on-blur
                )
            v-col(cols="3")
                v-text-field(
                    v-model="formAddress.state"
                    label="State *"
                    type="text"
                    clearable
                    :rules="[rules.required]"
                    validate-on-blur
                )
            v-col(cols="3")
                v-text-field(
                    v-model="formAddress.zipCode"
                    label="ZIP Code *"
                    type="text"
                    clearable
                    :rules="[rules.required]"
                    validate-on-blur
                )
        v-row
            v-col(cols="12")
                v-text-field(
                    v-model="formAddress.country"
                    label="Country *"
                    type="text"
                    clearable
                    validate-on-blur
                    :rules="[rules.required]"
                )

        v-row(v-if="showSave")
            v-col.d-flex.justify-end
                v-btn(color="success" :disabled="!eligibleToSave" :loading="isSaving" small outlined ripple @click="handleSetAddress(formAddress);")
                    v-icon mdi-content-save
                    | Save
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'AddressForm',
        data() {
            return {
                valid: false,
                formAddress: {
                    addressLine1: null,
                    addressLine2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    country: null,
                },
                isSaving: false,
                rules: {
                    required: (value: any) => !!value || 'This field is required',
                },
            }
        },
        methods: {
            resetFormAddress() {
                this.formAddress = {
                    addressLine1: null,
                    addressLine2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    country: null,
                };
            },
            initFormAddress() {
                if (this.validPrimaryCustomerAddress) {
                    this.formAddress = {
                        addressLine1: this.primaryCustomerAddress?.addressLine1 || null,
                        addressLine2: this.primaryCustomerAddress?.addressLine2 || null,
                        city: this.primaryCustomerAddress?.city || null,
                        state: this.primaryCustomerAddress?.state || null,
                        zipCode: this.primaryCustomerAddress?.zipCode || null,
                        country: this.primaryCustomerAddress?.country || null,
                    }
                } else if (this.validCustomerAddresses) {
                    this.formAddress = {
                        addressLine1: this.customerAddresses?.[0]?.addressLine1 || null,
                        addressLine2: this.customerAddresses?.[0]?.addressLine2 || null,
                        city: this.customerAddresses?.[0]?.city || null,
                        state: this.customerAddresses?.[0]?.state || null,
                        zipCode: this.customerAddresses?.[0]?.zipCode || null,
                        country: this.customerAddresses?.[0]?.country || null,
                    }
                } else {
                    this.resetFormAddress();
                }
            },
        },
        created() {
            this.initFormAddress();
        },
        watch: {
            formAddress: {
                handler(newVal) {
                    // Emit the form data when it changes
                    this.$emit('input', newVal);
                },
                deep: true,
                immediate: true
            }
        },
        computed: {
            eligibleToSave() {
                const { addressLine1, city, state, zipCode, country } = this.formAddress;
                return !!(addressLine1 && city && state && zipCode && country);
            },
            validCustomerAddresses() {
                return this.customerAddresses?.length > 0;
            },
            validPrimaryCustomerAddress() {
                return this.primaryCustomerAddress?.addressLine1?.length > 0;
            }
        },
        props: {
            showSave: {
                type: Boolean,
                default: false,
            },
            customerAddresses: Array,
            primaryCustomerAddress: Object,
			handleSetAddress: Function,
        },
    });
</script>
